import configureStore from '../store/configureStore';
export const setupRedux = () => {
  return configureStore();
};